import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { ContactInfo } from '@cassiopeia/integration';
import { CassiopeiaRootComponent, logAppVersion } from '@web/base';
import { fetchBackendEnvironment, fetchCassConfigJSON } from '@web/service';
import { getAppConfig } from './app/app.config';
import { providePaymentDetailsFactory } from './app/savings/pbu-payment-details-data-factory';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

logAppVersion('PBU', environment);

const fallbackContactInfo: ContactInfo = {
  phone: '+45 70 11 20 11',
  phoneOpeningHours: [
    {
      label: 'cas.phoneOpeningHoursMondayThroughFriday',
      hours: '9-16',
    },
    {
      label: 'cas.phoneOpeningHoursFriday',
      hours: '9-15',
    },
  ],
  email: 'info@pbu.dk',
  meeting: {
    collectPensionInfo: true,
    individual:
      'https://plugin.pexipengage.com/pbu#pexip-eyJpbnRlbnQiOiJzY2hlZHVsZSIsImZsb3ciOiJTTU9UUUMiLCJzdWJqZWN0X2dyb3VwLXR5cGUiOiJleHRlcm5hbElkIiwic3ViamVjdF9ncm91cC1pZHMiOiJQRVJTT05BTCJ9',
    group:
      'https://plugin.pexipengage.com/pbu#pexip-eyJpbnRlbnQiOiJzY2hlZHVsZSIsImZsb3ciOiJTTU9UUUMiLCJsYW5ndWFnZSI6ImRhIiwic3ViamVjdF9ncm91cC10eXBlIjoiZXh0ZXJuYWxJZCIsInN1YmplY3RfZ3JvdXAtaWRzIjoiR1JPVVAsV0VCSU5BUlMifQ==',
  },
  contactForm: {
    type: 'Form',
    group: 'Henvendelser',
    copyToComment: true,
    dueDays: 2,
    topics: [
      { text: 'cas.contactTopicQuestion' },
      { text: 'cas.contactTopicOngoingCases' },
      { text: 'cas.contactTopicGeneralInquiry' },
    ],
  },
};

(async () => {
  const [config, backendEnvironment] = await Promise.all([fetchCassConfigJSON(), fetchBackendEnvironment()]);

  const { settings, apiVersions } = backendEnvironment;
  const appConfig = getAppConfig({
    config,
    backendEnvironment,
    providers: [providePaymentDetailsFactory()],
    environment: { ...environment, apiVersions, contactInfo: settings?.contactInfo ?? fallbackContactInfo },
  });
  await bootstrapApplication(CassiopeiaRootComponent, appConfig);
})().catch(err => console.error('Error during application bootstrap:', err));

// Test comment for PBU-specific change
